import React from "react";
import useTokenIdParam from "hooks/useTokenIdParam";
import { Container } from "@chakra-ui/react";
import useFetchMetadata from "hooks/useFetchMetadata";
import TraitsPreviewContainer from "components/TraitsPreviewContainer";
import TraitsSelectorContainer from "components/TraitsSelectorContainer";
import DressingRoomProvider from "providers/DressingRoomProvider";
import TraitsShelfContainer from "components/TraitsShelfContainer";
import useAssets from "hooks/useAssets";
import BearSelectorContainer from "components/BearSelectorContainer";

const WardrobeBearPage: React.FC = () => {
  const tokenId = useTokenIdParam();
  const [bearMetadata, , isLoading] = useFetchMetadata(tokenId);
  const { traitsInWallet } = useAssets();

  return (
    <Container pt="12" pb="16">
      <DressingRoomProvider
        tokenId={tokenId!}
        initialTraits={bearMetadata?.traits}
        availableTraits={traitsInWallet}
      >
        <BearSelectorContainer basePath="/store" isLoading={isLoading} pb="3" />

        <TraitsPreviewContainer />
        <TraitsSelectorContainer />
        <TraitsShelfContainer />
      </DressingRoomProvider>
    </Container>
  );
};

export default WardrobeBearPage;
